import { WarningCircleIcon } from "@phosphor-icons/react"

import { Button } from "@/components/ui/button"
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty"
import { cn } from "@/lib/utils"

export type ErrorStateProps = {
  title: string
  description?: string
  className?: string
}

/**
 * Egységes hibaállapot "Újratöltés" gombbal - oldalrész, admin nézet vagy az egész app
 * (AppErrorBoundary) helyén. Az újratöltés a Firestore-figyelőket és a chunkokat is
 * újraindítja, ezért ez a legbiztosabb helyreállítás.
 */
export function ErrorState({ title, description, className }: ErrorStateProps) {
  return (
    <Empty role="alert" className={cn("border-none", className)}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <WarningCircleIcon />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        {description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Újratöltés
        </Button>
      </EmptyContent>
    </Empty>
  )
}
